module.exports = __webpack_public_path__ + "img/maintenance.64058d5e.svg";